import Vue from 'vue';
import Vuex from 'vuex';

import { alert } from './alert.module';
import { lang } from './lang.module';

let initialState = {
    alert: { ...alert.state },
};

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        refCount: 0,
        isLoading: false,
        secretKey: "",
        url: "",
        uploadCount: 0,
        isUploading: false,
    },
    modules: {
        alert,
        lang,
    },
    mutations: {
        reset (state) {
            Object.keys(state).forEach(key => {
                Object.assign(state[key], initialState[key]);
            });
        },
        loading (state, isLoading) {
        // console.log({isLoading})
            if (isLoading) {
                state.refCount++;
                state.isLoading = true;
            } else if (state.refCount > 0) {
                state.refCount--;
                setTimeout(function () {
                    state.isLoading = (state.refCount > 0);

                    if (!state.isLoading) {
                        state.isUploading = false;
                    }
                }, 300);
            }
        },
        setLoginInfo (state, { secretKey, url }) {
            state.secretKey = secretKey;
            state.url = url;
        },
        clearLoginInfo () {
            state.secretKey = null;
            state.url = null;
        },
        uploading (state, isUploading) {
            if (isUploading) {
                state.uploadCount++;
                state.isUploading = true;
            } else if (state.uploadCount > 0) {
                state.uploadCount--;
            }
        },
    },
});



// WEBPACK FOOTER //
// ./src/store/index.js